import apiClient from './client';
import type {
  AthleteNote,
  DeletedAthleteNote,
  CreateAthleteNoteRequest,
  UpdateAthleteNoteRequest,
  AthleteNotesResponse,
  NoteType,
} from '../types/athleteNote';

export const athleteNotesApi = {
  /**
   * Создать заметку о спортсмене
   */
  async create(athleteId: string, data: CreateAthleteNoteRequest): Promise<AthleteNote> {
    const response = await apiClient.post<AthleteNote>(
      `/athletes/${athleteId}/notes`,
      data
    );
    return response.data;
  },

  /**
   * Получить список заметок спортсмена
   */
  async getByAthleteId(
    athleteId: string,
    params?: {
      limit?: number;
      offset?: number;
      type?: NoteType;
    }
  ): Promise<AthleteNotesResponse> {
    const response = await apiClient.get<AthleteNotesResponse>(
      `/athletes/${athleteId}/notes`,
      { params }
    );
    return response.data;
  },

  /**
   * Получить заметку по ID
   */
  async getById(athleteId: string, noteId: string): Promise<AthleteNote> {
    const response = await apiClient.get<AthleteNote>(
      `/athletes/${athleteId}/notes/${noteId}`
    );
    return response.data;
  },

  /**
   * Обновить заметку
   */
  async update(
    athleteId: string,
    noteId: string,
    data: UpdateAthleteNoteRequest
  ): Promise<AthleteNote> {
    const response = await apiClient.put<AthleteNote>(
      `/athletes/${athleteId}/notes/${noteId}`,
      data
    );
    return response.data;
  },

  /**
   * Удалить заметку
   */
  async delete(athleteId: string, noteId: string): Promise<void> {
    await apiClient.delete(`/athletes/${athleteId}/notes/${noteId}`);
  },

  /**
   * Корзина: удалённые за 30 дней, свежие первыми
   */
  async trash(athleteId: string): Promise<DeletedAthleteNote[]> {
    const response = await apiClient.get<{ notes: DeletedAthleteNote[] | null }>(`/athletes/${athleteId}/notes/trash`);
    return response.data?.notes ?? [];
  },

  /**
   * Вернуть из корзины (повтор - та же запись)
   */
  async restore(athleteId: string, noteId: string): Promise<AthleteNote> {
    const response = await apiClient.post<AthleteNote>(`/athletes/${athleteId}/notes/${noteId}/restore`);
    return response.data;
  },
};
